import React from 'react';
import { Modal } from 'antd';
import styles from './modifyPasswordModal.module.scss';

import ModifyPassword from './index';

interface IProps {
  show: boolean;
  onClose: () => void;
}

const ModifyPasswordModal: React.FC<IProps> = ({ show, onClose }) => {
  return (
    <>
      <Modal
        maskClosable={false}
        className={styles.modal}
        forceRender
        width={368}
        title="设置密码"
        visible={show}
        onCancel={onClose}
        footer={null}
        centered
        destroyOnClose
      >
        {show ? <ModifyPassword onSuccess={onClose} /> : null}
      </Modal>
    </>
  );
};

export default ModifyPasswordModal;
